<template>
    <div>
        <CRow>
            <CCol sm="12">
                <CCard>
                    <CCardHeader>
                        <strong>ایجاد مکالمه جدید</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CForm @keyup.enter="validator();submit()">
                            <CRow>
                                <CCol sm="3">
                                    <CInput v-model="form.title.val" :description="form.title.inv" label="موضوع" />
                                </CCol>
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.department.val"
                                        :description="form.department.inv"
                                        label="دپارتمان"
                                        :options="[
                                            {value: '1', label:'واحد مالی'},
                                            {value: '2', label: 'واحد پشتیبانی'},
                                            {value: '3', label: 'واحد خطوط'},
                                            {value: '4', label: 'وب‌سرویس'}
                                        ]"
                                        placeholder="انتخاب کنید"
                                        @change="form.department.val=$event.target.value"
                                    />
                                </CCol>
                                    <CCol sm="3">
                                        <CSelect
                                        v-model="form.priority.val"
                                        :description="form.priority.inv"
                                        label="اولویت"
                                        :options="[
                                            {value: '1', label:'کم'},
                                            {value: '2', label: 'عادی'},
                                            {value: '3', label: 'زیاد'},
                                            {value: '4', label: 'محرمانه'}
                                        ]"
                                        placeholder="انتخاب کنید"
                                        @change="form.priority.val=$event.target.value"
                                    />
                                </CCol>
                                <CCol sm="3">
                                    <CTextarea v-model="form.message_text.val" :description="form.message_text.inv" label="پیام" rows="3"
                                        @keyup.enter="access=false" />
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="3">
                                    <CInputFile v-show="$store.state.perms.can_attach_file_in_all_user_conversations ||
                                        $store.state.perms.can_attach_file_in_same_group_user_conversations ||
                                        $store.state.perms.can_attach_file_in_user_conversations"
                                        label="آپلود فایل"
                                        @change="file=$event[0]"
                                    />
                                </CCol>
                            </CRow>
                        </CForm>
                        <br>
                        <div class="form-group form-actions">
                            <CButton @click="validator();submit()" color="primary"> ارسال</CButton>
                        </div>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import validator from '../mixins'
export default {
    mixins: { validator },
    components: { ModelSelect },
    data() {
        return {
            form: {
                title: { val: '', inv: '', v: { req: true, max: 512 } },
                message_text: { val: '', inv: '', v: { req: true, max: 2048 } },
                department: { val: '', inv: '', v: { req: true, max: 4 } },
                priority: { val: '', inv: '', v: { req: true, max: 4 } },
            },
            file: '',
            disable: false,
            access: true,
        }
    },
    methods: {
        submit(){
            if(this.access){
                if (this.disable == false) {
                    const data = new FormData();
                    for (const key in this.form){
                        if(key != 'message_text'){
                            data.set(key, this.form[key].val);
                        }                    
                    }
                    this.axios.post('conversations/', data)
                        .then(res => {
                            const conversation_id = res.data.id;
                            if(this.file != ''){
                                const reader = new FileReader();
                                reader.readAsDataURL(this.file);
                                reader.onload = () => {
                                    const data = new FormData();
                                    data.set('base64_file', reader.result.split('base64,')[1]);
                                    data.set('file_type', reader.result.split(':').pop().split(';')[0]);
                                    data.set('file_name', this.file.name);
                                    this.$notify({
                                        group: 'foo',
                                        type: 'success',
                                        text: 'فایل در حال آپلود است. لطفا صبور باشید.'
                                    });
                                    this.axios.post('upload_file/', data)
                                        .then(res => {
                                            const data = new FormData();
                                            data.set('message_text', String(this.form.message_text.val).replaceAll('\n', '<br>'));
                                            data.set('conversation_id', conversation_id);
                                            data.set('attachment_id', res.data.id);
                                            this.axios.post('conversation_messages/', data)
                                                .then(() => {
                                                    this.$notify({
                                                        group: 'foo',
                                                        type: 'success',
                                                        text: 'ارسال با موفقیت انجام شد.'
                                                    });
                                                    for (const key in this.form) {
                                                        this.form[key].val = '';
                                                    }
                                                    this.$router.push(`/support/${conversation_id}/messages`);
                                                })
                                                .catch(() => {
                                                    this.$notify({
                                                        group: 'foo',
                                                        type: 'error',
                                                        text: 'خطا! لطفا مجددا تلاش کنید.'
                                                    });
                                                })
                                        })
                                        .catch(() => {
                                            this.$notify({
                                                group: 'foo',
                                                type: 'error',
                                                text: 'خطا! لطفا مجددا تلاش کنید.'
                                            });
                                        })
                                }
                            } else {
                                const data = new FormData();
                                data.set('message_text', String(this.form.message_text.val).replaceAll('\n', '<br>'));
                                data.set('conversation_id', conversation_id);
                                this.axios.post('conversation_messages/', data)
                                    .then(() => {
                                        this.$notify({
                                            group: 'foo',
                                            type: 'success',
                                            text: 'ارسال با موفقیت انجام شد.'
                                        });
                                        for (const key in this.form) {
                                            this.form[key].val = '';
                                        }
                                        this.$router.push(`/support/${conversation_id}/messages`);
                                    })
                                    .catch(() => {
                                        this.$notify({
                                            group: 'foo',
                                            type: 'error',
                                            text: 'خطا! لطفا مجددا تلاش کنید.'
                                        });
                                    })
                            }
                        })
                }
            }
            this.access = true;
        }
    },
    beforeCreate() {
        if (this.$store.state.perms.can_start_new_conversation == false
            && this.$store.state.verif == false) {
            this.$router.push('/403')
        }
    },
}
</script>
